export default "__VITE_ASSET__CrCGcbt0__"